module.exports = __webpack_public_path__ + "img/college2.a0d0e43c.png";